/**
 * @repo/constants
 * 
 * Shared constants for the Alli monorepo
 */

export * from './therapy'
export * from './locations'
export * from './time'
export * from './between-sessions'
export * from './resources'
export * from './workshops'
export * from './supervision'
export * from './internship'

// App-wide constants
export const APP_NAME = 'Alli'
export const APP_DESCRIPTION = 'Affordable therapy for everyone'

// Feature flags
export const FEATURES = {
  ENABLE_COUPLES_THERAPY: true,
  ENABLE_GROUP_SESSIONS: false,
  ENABLE_VIDEO_CALLS: true,
  ENABLE_PAYMENT_PROCESSING: true,
  ENABLE_AI_MATCHING: false
} as const

// API endpoints
export const API_ENDPOINTS = {
  THERAPIST_API: process.env.NEXT_PUBLIC_THERAPIST_API_URL || 'http://localhost:3001/api',
  CLIENT_API: process.env.NEXT_PUBLIC_CLIENT_API_URL || 'http://localhost:3002/api'
} as const

// File upload limits
export const UPLOAD_LIMITS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf']
} as const

// Cache durations (in seconds)
export const CACHE_DURATION = {
  PROFILE: 30 * 60, // 30 minutes
  AVAILABILITY: 5 * 60, // 5 minutes
  SUPERVISORS: 24 * 60 * 60, // 24 hours
  STATIC_DATA: 7 * 24 * 60 * 60 // 7 days
} as const